import Blogs from "../blogs/Blogs";
import ContactUs from "../contact-us/ContactUs";
import Feedback from "../feedbacks/Feedback";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import HeroSection from "../hero-section/HeroSection";
import HowWeDifferent from "../how-we-different/HowWeDifferent";
import OurStory from "../story/OurStory";
import OurTechnologies from "../technologies/OurTechnologies";
import Services from "../services/Services";
import OurProcess from "../process/OurProcess";
import Portfolio from "../portfolio/Portfolio";

const Home = () => {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Nexasoft Infotech",
            "url": "https://nexasoftinfotech.com",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://nexasoftinfotech.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          })
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Software Development",
            "provider": {
              "@type": "Organization",
              "name": "Nexasoft Infotech"
            },
            "areaServed": "Worldwide",
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Software Development Services",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Web Development",
                    "description": "Modern web development using React.js, Next.js, Node.js, and serverless architecture"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Mobile App Development",
                    "description": "Cross-platform mobile app development using React Native and Flutter"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "AI/ML Solutions",
                    "description": "AI and Machine Learning integration for modern software applications"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "UI/UX Design",
                    "description": "Premium UI/UX design services for web and mobile applications"
                  }
                }
              ]
            }
          })
        }}
      />
      <main className="bg-gradient-to-br from-neutral-950 via-neutral-900 to-neutral-950 min-h-screen overflow-x-hidden w-full relative">
        {/* Animated background gradient overlay */}
        <div className="fixed inset-0 bg-gradient-to-br from-primary-900/10 via-transparent to-accent-orange/5 pointer-events-none -z-10" />
        <div className="fixed inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(0,120,209,0.15),transparent_50%)] pointer-events-none -z-10" />
        <Header />
        <HeroSection />
        <HowWeDifferent />
        <OurTechnologies />
        <OurProcess />
        <Services />
        <Portfolio />
        <Feedback />
        <OurStory />
        <Blogs />
        <ContactUs />
        <Footer />
      </main>
    </>
  );
};

export default Home;
